export const formTypes = {
  userEditsItself: 'userEditsItself',
  adminCreatesNewUser: 'adminCreatesNewUser',
  adminEditsUser: 'adminEditsUser',
};

export const formTitles = {
  userEditsItself: 'Eigene Daten bearbeiten',
  adminCreatesNewUser: 'Neuen Benutzer anlegen',
  adminEditsUser: 'Benutzer bearbeiten',
};
